import Swiper from 'swiper/bundle';

function initSliderInfoSenar() {
	document.querySelectorAll(".slide-infoSenar-container").forEach(slide => {
		const nextButton = slide.querySelector(".swiper-button-next");
		const prevButton = slide.querySelector(".swiper-button-prev");

		const swiper = 	new Swiper(slide, {
			slidesPerView: "auto",
			spaceBetween: 74,
			centeredSlides: true,
			grabCursor: 'true',

			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
		});
	});
}

if (document.querySelector(".slide-infoSenar-container")) {
	initSliderInfoSenar();
}
